import { render, staticRenderFns } from "./PMDashboardTableExpansion.vue?vue&type=template&id=b6d8867e&scoped=true&"
import script from "./PMDashboardTableExpansion.vue?vue&type=script&lang=js&"
export * from "./PMDashboardTableExpansion.vue?vue&type=script&lang=js&"
import style0 from "./PMDashboardTableExpansion.vue?vue&type=style&index=0&id=b6d8867e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d8867e",
  null
  
)

export default component.exports